module.exports = __webpack_public_path__ + "img/bluetooth@3x.da8483e2.jpg";